import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ShieldCheck } from 'lucide-react'
import { useAuthStore } from '@/lib/auth.store'
import { fmtDateLong } from '@/lib/format-date'

/**
 * AP-38-E (8.6) — „Richte bis *Datum* die Zwei-Faktor-Anmeldung ein" mit Knopf
 * „Jetzt einrichten". Nur, solange die Person nicht eingerichtet hat und für sie
 * eine Frist gilt; nach der Frist verlangt der Server die Einrichtung selbst.
 */
export function ZweiFaktorHinweis() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const zf = useAuthStore((s) => s.user?.zweiFaktor)
  if (!zf || zf.eingerichtet || !zf.pflichtAb || zf.abgeschaltet) return null

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-md border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-sm text-foreground">
      <ShieldCheck size={18} className="shrink-0 text-amber-600 dark:text-amber-400" />
      <span className="flex-1">{t('zweiFaktor.hinweisBanner', { datum: fmtDateLong(zf.pflichtAb) })}</span>
      <button
        type="button"
        onClick={() => navigate('/profile#zwei-faktor')}
        className="rounded-md bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground hover:bg-primary/90"
      >
        {t('zweiFaktor.jetztEinrichten')}
      </button>
    </div>
  )
}
